import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { Dialog, DialogContent, DialogTrigger } from 'gcs-common/design-system/ui/dialog';
import { calculateMediaIconFromType, mimeTypeIsImage } from 'gcs-common/helper/mediaHelper';
import brokenImage from 'gcs-common/img/broken_image.svg';
import type { ReactEventHandler } from 'react';
import { useState } from 'react';
import TicketMessageBubble from '../TicketMessageBubble/TicketMessageBuble';

interface TicketMessageMediaProps {
  ticketId: string;
  id: string;
  fromBeem: boolean;
  thumbnailUrl?: string | null;
  createdAt: string;
  name: string;
  mimeType?: string | null;
  url: string;
}

const TicketMessageMedia = (props: TicketMessageMediaProps) => {
  const { fromBeem, thumbnailUrl, createdAt, name, mimeType, url } = props;
  const [showDialog, setShowDialog] = useState(false);

  const mediaIcon = calculateMediaIconFromType(mimeType);

  const handleImageError: ReactEventHandler<HTMLImageElement> = (e) => {
    e.currentTarget.src = brokenImage;
  };

  const isPDF = mimeType === 'application/pdf';

  return (
    <TicketMessageBubble isFromMe={fromBeem} createdAt={createdAt}>
      <div>
        {isPDF ? (
          <a
            href={url}
            download={name}
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-48 w-48 items-center justify-center rounded-xl bg-gray-100 transition hover:bg-gray-200"
          >
            <IconComponent Icon={mediaIcon} size={ICON_SIZE.LARGE} color={ICON_COLOR.DARKEST_GREY} />
          </a>
        ) : (
          <Dialog open={showDialog} onOpenChange={(open) => setShowDialog(open)}>
            {mimeTypeIsImage(mimeType) ? (
              <DialogTrigger asChild>
                <img
                  alt={name}
                  src={thumbnailUrl ?? undefined}
                  onError={handleImageError}
                  className="h-full w-full max-w-[600px] rounded-[8px] border border-gray-300 object-cover"
                />
              </DialogTrigger>
            ) : (
              <div className="flex h-48 w-48 items-center justify-center rounded-xl bg-gray-100">
                <IconComponent Icon={mediaIcon} size={ICON_SIZE.LARGE} color={ICON_COLOR.DARKEST_GREY} />
              </div>
            )}
            <DialogContent className="flex h-full max-h-screen w-full max-w-screen-md items-center justify-center">
              <img
                alt={name}
                src={url}
                onError={handleImageError}
                className="h-full max-h-full w-full max-w-full object-contain"
              />
            </DialogContent>
          </Dialog>
        )}
      </div>
    </TicketMessageBubble>
  );
};

export default TicketMessageMedia;
